








































import { BFormInput } from 'bootstrap-vue';
import ZenMultiselect from '@reciprocity/multiselect';
import DatePicker from '@reciprocity/date-picker';
import { parseISO, subDays, format } from 'date-fns';
import { STOP_REPEATING, StopRepeatingOptions, DATE_FORMAT } from './utils';

const TODAY = new Date();

export default {
  name: 'RepeatEnd',
  components: {
    BFormInput,
    ZenMultiselect,
    DatePicker,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      STOP_REPEATING,
      StopRepeatingOptions,
    };
  },
  watch: {
    'form.endDate'() {
      this.initStopOn();
    },
  },
  created() {
    if (!this.form.stopRepeating) {
      this.form.stopRepeating = STOP_REPEATING[0];
    }
    this.initStopOn();
  },
  methods: {
    showIfEquals(option) {
      return this.form.stopRepeating && this.form.stopRepeating.value === option;
    },
    stopOnDisabledDates(date) {
      return (
        (this.form.startDate && date < parseISO(this.form.startDate)) ||
        (this.form.endDate && date < parseISO(this.form.endDate)) ||
        date < subDays(TODAY, 1)
      );
    },
    initStopOn() {
      if (!this.form.endDate) return;
      const dueOn = parseISO(this.form.endDate);
      if (this.form.stopOn) {
        const stopOn = parseISO(this.form.stopOn);
        if (stopOn < dueOn) {
          this.updateStopOn(dueOn);
        }
      } else {
        this.updateStopOn(dueOn);
      }
    },
    updateStopOn(dueOn) {
      if (dueOn >= TODAY) {
        this.form.stopOn = this.form.endDate;
      } else {
        this.form.stopOn = format(TODAY, DATE_FORMAT);
      }
    },
  },
};
